"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Denotes the priority, purpose and placement of the settings component.
 */
var SettingsType;
(function (SettingsType) {
    SettingsType[SettingsType["MAIN"] = 1] = "MAIN";
    SettingsType[SettingsType["BOTTOM"] = 2] = "BOTTOM";
    SettingsType[SettingsType["CENTER"] = 3] = "CENTER";
})(SettingsType = exports.SettingsType || (exports.SettingsType = {}));
//# sourceMappingURL=settings-type.js.map